import * as React from 'react'
import { MultiValueProps as ReactSelectMultiValueProps } from 'react-select'
import { Tag, TagTypes, TagProps } from '../tag/tag'
import { identifiers } from './multi-select.constants'
import { OptionTypeBase } from '../../interface/optionTypeBase'

export interface MultiValueProps<OptionType extends OptionTypeBase>
  extends ReactSelectMultiValueProps<OptionType>,
    Pick<TagProps, 'readOnly' | 'selected' | 'disabled' | 'maxLength'> {
  id: string
  optionValidatorFn?(option: OptionType): boolean
  optionIsWarningFn?(option: OptionType): boolean
  onTagClick?(option: OptionType): void
  onContextMenuClick?(event: React.MouseEvent, option: OptionType): void
}

const getTagType = (isValid: boolean, isWarning: boolean) => {
  if (isValid) {
    if (isWarning) {
      return TagTypes.WARNING
    }
    return TagTypes.DEFAULT
  }

  return TagTypes.ERROR
}

export function MultiValue<OptionType extends OptionTypeBase = OptionTypeBase>({
  id,
  data,
  removeProps,
  readOnly,
  selected,
  disabled,
  maxLength,
  children,
  optionValidatorFn = () => true,
  optionIsWarningFn = () => false,
  onTagClick = () => undefined,
  onContextMenuClick = () => {},
}: MultiValueProps<OptionType>) {
  const type = getTagType(optionValidatorFn(data), optionIsWarningFn(data))

  const handleContextMenu = (event: React.MouseEvent) => {
    onContextMenuClick(event, data)
  }

  return (
    <Tag
      {...(removeProps as any)}
      readOnly={readOnly || data?.isNonDeletable}
      selected={selected}
      disabled={disabled}
      maxLength={maxLength}
      data-id={`${id}__${identifiers.option}`}
      type={type}
      onTagClick={onTagClick.bind(null, data)}
      onContextMenuClick={handleContextMenu}
    >
      {children}
    </Tag>
  )
}
